import { IGetGestaoEpiDropDownUseCase } from "../../../presentation/useCases/read/get_gestao_epi_drop_down_use_case";
import { GestaoEpiDropdown } from "../../models/gestao_epi_dropdown";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

/**
 * GetGestaoEpiDropDownUseCase
 */

export class GetGestaoEpiDropDownUseCase implements IGetGestaoEpiDropDownUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async getGestaoEpiDropDown(
  ): Promise<GestaoEpiDropdown[]> {
    return await this.repository.getGestaoEpiDropDown();
  }
}
